import ConfirmationModal from 'components/confirmation-modal';
import React, { useState } from 'react';
import styled from 'styled-components';
interface PopupProps {
    key: number;
    index: number;
    thumbnailImg: any;
    videoSrc: string
}


const VideoContainer = styled.div`
    .video-body{
        position: relative;
        margin-top: -32px;
        z-index: 99;
    }
    .fullWidth{
        height: 100px;
    }
    .mobileWidth{
        height: 80px;
    }
`
const VideoPlayerPopup: React.FC<PopupProps> = ({ key, index, thumbnailImg, videoSrc }) => {
    const [modal, setModal] = useState(false);

    const openModal = () => {
        setModal(!modal);
    };

    return (
        <VideoContainer>
            {
                modal &&
                <ConfirmationModal
                    closable
                    onCancel={() => setModal(false)}
                    modalBody={<div className="video-body">
                        <iframe id="iframeVideo" width="100%" height="100%" src={videoSrc}
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>}>

                </ConfirmationModal>

            }
            <div className={`video-series ${index === 0 ? 'fullWidth': 'mobileWidth'}`} >
                <div className="videoDiv"></div>
                <img id="img1" src={thumbnailImg} width='100' height={index === 0 ? '100' : '80'} data-toggle="modal" data-target="#myVideoModal" onClick={openModal} />
            </div>
        </VideoContainer>
    )
}

export default VideoPlayerPopup;